module.exports = __webpack_public_path__ + "static/media/Fondo-Aprobacion.91322f05.png";